export default {
    'name': 'play-l',
    'width': '123',
    'height': '123',
    'viewBox': '0 0 123 123',
    'data': '<path d=\'M101.101 56.3157C105.074 58.6302 105.074 64.3698 101.101 66.6843L36.5204 104.309C32.5204 106.64 27.5 103.754 27.5 99.1248L27.5 23.8752C27.5 19.2459 32.5204 16.3605 36.5204 18.6909L101.101 56.3157Z\' fill=\'#006CFD\'/>'
}
